<style>
    mark {
        color: #9e0505 !important;
        padding: 0px !important;
    }

    .icon {
        clear: both;
        float: left;
        margin-top: 15px;
        margin-right: 6px;
        color: #0b3e6f !important;
        font-size: 18px;
    }

    .result {
        padding: 10px;
        border-bottom: 1px solid ghostwhite;
    }

    .result .searchTitle {
        font-size: 18px;
        float: left;
        color: #0b3e6f;
        margin-bottom: 10px;
    }

    .result .searchContent {
        clear: both;
    }

    .labelD {
        color: #0b3e6f;
        word-break: break-word;
        font-weight: bold;
    }

    .contentD {
        word-break: break-word;
    }

</style>
<template>
    <v-container>
        <v-card id="searchDiv">
            <v-toolbar color="cyan" dark>
                <v-toolbar-title>{{$t(formName)}}</v-toolbar-title>
            </v-toolbar>
            <slot name="searchForm">
                <v-form @keyup.enter.native="onSearch">
                    <v-layout row wrap>
                        <v-flex xs9 v-for="item in inputSearchItems" style="padding:10px">
                            <c-textbox :type="item.type" :icon="item.icon" :label="$t(item.label)"
                                       v-model.trim="values[item.name]"
                                       :placeholder="$t(item.placeHolder)" autofocus="true"
                            ></c-textbox>
                        </v-flex>
                        <v-flex xs3>
                            <v-btn color="primary" dark @click="onSearch" style="margin-top: 15px;">
                                <v-icon dark left>search</v-icon>
                                {{$t('lang.common.search')}}
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-form>
            </slot>
            <slot name="tableData">
                <v-layout row wrap>
                    <v-flex xs4>
                        <v-data-table :items="items" id="searchResult" hide-headers
                                      :total-items="totalRows"
                                      :rows-per-page-items="rowsPerPageItems"
                                      @update:pagination="onPaging">
                            <template slot="items" slot-scope="data">
                                <td>
                                    <v-icon right class="icon">fa fa-credit-card</v-icon>
                                    <div class="result" @click="showDetail(data.item)">
                                        <div class="searchTitle">
                                            {{data.item["infini_title"]}}
                                        </div>
                                        <div class="searchContent">
                                            {{data.item["infini_content"]}}
                                        </div>
                                    </div>
                                </td>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex xs8 style="padding: 0px 10px">
                        <div id="detailContainer" class="col-xs-12" v-show="show"
                             style="padding: 10px; font-size: 12px; border:1px solid gray; border-radius: 8px; display: none"></div>
                        <div id="networkTopo" class="col-xs-12" style="overflow: hidden;position: relative">
                            <div>
                                <v-btn color="cyan" fab small icon dark  @click="onZoomFit" style="float:left">
                                    <v-icon dark >open_with</v-icon>
                                </v-btn>
                                <v-btn color="light-blue" fab small  icon dark @click="onZoomIn" style="float:left" >
                                    <v-icon dark >zoom_in</v-icon>
                                </v-btn>
                                <v-btn color="orange" fab small  icon dark  @click="onZoomOut" style="float:left" >
                                    <v-icon dark >zoom_out</v-icon>
                                </v-btn>
                                <v-btn color="error"  fab small  icon dark  @click="onClearTopo" style="float:left" >
                                    <v-icon dark >clear_all</v-icon>
                                </v-btn>
                                <v-btn color="purple"  fab small  icon dark @click="onReOrder" style="float:left" >
                                    <v-icon dark >reorder</v-icon>
                                </v-btn>
                                <v-btn color="primary"  fab small icon dark @click="onSaveImage" style="float:left">
                                    <v-icon dark>save</v-icon>
                                </v-btn>
                                <!--v-btn color="yellow"  fab small icon dark @click="onAddNote" style="float:left">
                                    <v-icon dark>notes</v-icon>
                                </v-btn-->
                            </div>
                            <svg id="networkDesign" width="1000px" height="1000px" xmlns="http://www.w3.org/2000/svg">
                            </svg>
                        </div>
                    </v-flex>
                </v-layout>
            </slot>
        </v-card>
    </v-container>
</template>

<script>
    import CTextbox from "../../../components/form/Textbox";
    import axios from "axios";
    import Mark from "mark.js";
    import Network from "../../../../public/plugin/network/network";

    export default {
        name: 'universal-search',
        components: {CTextbox},
        inheritAttrs: true,
        props: {
            formName: {
                type: String,
                default: 'lang.search.title'
            },
            searchUrl: {
                type: String,
                default: "/fullTextSearch/search"
            },
            rowsPerPageItems: {
                type: [Array, Number],
                default: () => [10, 20, 30, 40, 50]
            },
            pageSize: {
                type: Number,
                default: 10
            }
        },

        data: () => {
            return {
                inputSearchItems: [
                    {
                        type: "text",
                        name: "query",
                        label: "lang.search.input"
                    }
                ],
                show: false,
                values: {},
                items: [],
                model: {},
                zoom:1,
                selectFlowDlg: false,
                formDlg: false,
                pagination: {
                    rowsPerPage: 20
                },
                selectedItem: {},
                currentPage: 1,
                totalRows: 0
            }
        },

        created() {
            //VueController.push(this, "taskManager");
            //console.log(VueController);
            //this.search();
        },

        mounted(){
            Network.init("networkDesign",this,[],[]);
        },

        destroyed() {
            //VueController.removeComponentByEl(this);
            //console.log(VueController);
        },

        methods: {
            onSearch: function () {
                this.currentPage = 1;
                this.search();
            },

            displayDate: function (data, format) {
                if (data == null) {
                    return "";
                }
                let dateDate = new Date(data);
                let month = dateDate.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let year = dateDate.getFullYear();
                let date = dateDate.getDate();
                if (date < 10) {
                    date = "0" + date;
                }
                let second = dateDate.getSeconds();
                let minute = dateDate.getMinutes();
                let hour = dateDate.getHours();
                let dateStr = format.replace("dd", date).replace("MM", month).replace("yyyy", year).replace("mm", minute).replace("hh", hour).replace("ss", second);
                return dateStr;
            },

            search: function () {
                this.show = false;
                let search = this.values["query"];
                if (search == undefined) {
                    search = "";
                } else {
                    search = encodeURI(search);
                }

                if(search.trim() == ""){
                    return;
                }

                axios.post(process.env.VUE_APP_API_URL + this.searchUrl + "?pageSize=" + this.pageSize + "&page=" + this.currentPage + "&search=" + search).then((data) => {
                    console.log("-after post get data");
                    console.log(data);
                    this.items = data.items;
                    this.totalRows = data.count;
                    console.log(this.pagination);
                    let query = this.values["query"];
                    if (query == null || query == undefined)
                        return;
                    query = query.replace(/\"/g, "");
                    query = query.replace(/\'/g, "");
                    console.log(query);
                    let option = {
                        className: "mark",
                        caseSensitive:false
                    };
                    let instance = new Mark(document.getElementById("searchResult"));
                    instance.mark(query, option);


                });
            },

            topoSearch:function(nodeId, content){
                content = encodeURI(content);
                axios.post(process.env.VUE_APP_API_URL + this.searchUrl + "?pageSize=-1&page=0&search=" + content).then((data) => {
                    if(data.items.length == 0){
                        return;
                    }
                    for(let i=0;i<data.items.length;i++){
                        if(Network.addNode(data.items[i])) {
                            let relation = {
                                node1: nodeId,
                                node2: data.items[i].id
                            }
                            Network.lstRelation.push(relation);
                        }
                    }
                    Network.adjustPosition();
                    Network.draw();

                });

            },

            onZoomFit: function(){
                let canvas = document.getElementById("searchDiv");
                canvas.requestFullscreen();
                this.zoom = 1;
                //canvas.style.transform = "scale("+this.zoom+","+this.zoom+")";
                Network.onZoom(this.zoom);
            },

            onZoomIn: function(){
                let canvas = document.getElementById("networkDesign");
                if(this.zoom<10){
                    this.zoom+=0.1;
                    Network.onZoom(this.zoom);
                }
            },

            onZoomOut: function(){
                let canvas = document.getElementById("networkDesign");
                if(this.zoom>0.2){
                    this.zoom-=0.1;
                    //canvas.style.transform = "scale("+this.zoom+","+this.zoom+")";
                    Network.onZoom(this.zoom);
                }
            },

            onClearTopo:function(){
                Network.clear();
            },

            onReOrder:function(){
                Network.adjustPosition();
                Network.draw();
            },

            onSaveImage: function(){
                Network.saveSVG();
            },

            onPaging: function (page) {
                console.log("paging");
                this.pagination = page.page;
                this.currentPage = page.page;
                this.pageSize = page.rowsPerPage;
                this.search();
            },

            showDetail: function (item) {
                this.show = false;
                let detail = document.getElementById("detailContainer");
                detail.innerHTML = "";
                item.title = item.infini_title;
                Network.addNode(item,false);
                Network.adjustPosition();
                Network.draw();


                for (let key in item) {

                    if (key.indexOf("infini") == 0) {
                        continue;
                    }
                    let div = document.createElement("div");
                    div.setAttribute("class", "layout row wrap");
                    detail.appendChild(div);
                    let label = document.createElement("div");
                    label.setAttribute("class", "labelD flex xs3");
                    label.innerHTML = key;
                    div.appendChild(label);
                    let valueDiv = document.createElement("div");
                    valueDiv.setAttribute("class", "contentD flex xs9");
                    div.appendChild(valueDiv);
                    let value = item[key];
                    //console.log(key + "-" + value);
                    if (typeof value == "number") {
                        valueDiv.innerHTML = value;
                    } else if (typeof value == "string") {
                        valueDiv.innerHTML = value;
                    } else if (value instanceof Array) {
                        valueDiv.innerHTML = value;
                    } else {
                        valueDiv.innerHTML = value;
                    }

                }
/*
                var query = $("#query").val();
                query = query.replace(/\"/g, "");
                query = query.replace(/\'/g, "");
                console.log(query);
                var option = {
                    className: "mark"
                };
                $("#detailContainer").mark(query, option);
*/

            },

            isEmpty: function (obj) {
                for (let key in obj) {
                    if (obj.hasOwnProperty(key))
                        return false;
                }
                return true;
            }
        }


    }
</script>
